import { Injectable } from "@angular/core";
import { CrudService } from "app/shared/crud-service";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Resolve
} from "@angular/router";
import { Observable  } from "rxjs";
import { NotificationsDTO } from "../models/notifications-aniversario.model";
import { AuthenticationService } from "app/helpers/authentication.service";
import { EnumFuncoes } from "app/shared/enum.service";
import { Functions } from "app/helpers/functions";
import { reject } from "lodash";


@Injectable({
    providedIn: "root"
})
export class NotificationsService extends CrudService<NotificationsDTO> implements Resolve<any>{
    constructor(
        protected http: HttpClient,
        private functions: Functions,
        private _authenticatorService: AuthenticationService,
        
    ) {
        super(http, `${environment.apiUrl}/v1/Notificacoes/`);
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {}


    getAniversarios(): Promise<any> {
        let vendedores = "";
        let params = "";

        if (this._authenticatorService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.Gestor).ativo ||
            this._authenticatorService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.VendedorBalcão).ativo) {
            vendedores = this._authenticatorService.currentUserValue.userDetails.usuariosGestor;

            if (this._authenticatorService.currentUserValue.userDetails.vendedorId > 0) {
                const array = this.functions.stringToArray(vendedores, ',', true);
                if (!array.find(x => x == this._authenticatorService.currentUserValue.userDetails.vendedorId)) {
                    vendedores += ',' + this._authenticatorService.currentUserValue.userDetails.vendedorId.toString();
                }
            }
            params += vendedores;
        } else if(this._authenticatorService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.VendedorCampo).ativo){

            params += this._authenticatorService.currentUserValue.userDetails.vendedorId;
        } else if(this._authenticatorService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.Administrador).ativo){
            params = '';
        }

        return new Promise((resolve, reject) => {
            this.http.post(`${environment.apiUrl}/v1/Notificacoes/Aniversariantes`, {vendedores: params}).subscribe((response: any) => {
                resolve(response);
            }, reject);
        });
    }

    notificacaoLida(id): Promise<any> {

        return new Promise(async (resolve, reject) => {
            this.http.put(`${environment.apiUrl}/v1/Notificacoes/LerNotificacao/${id}`, {})
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    public readAllAtividade(vendedorId): Promise<string> {
        return this.http.put(`${environment.baseUrl}/Notificacoes/marcar-todas-como-lidas?vendedorId=${vendedorId}`,
            {},
            { responseType: 'text' }
        ).toPromise();
        
    }

    public deleteNotificationAtividadeById(id): Promise<string> {
        return this.http.delete(`${environment.baseUrl}/Notificacoes/${id}`, {responseType: 'text'}).toPromise();
    }

    public deleteNotificationAniversarioById(id): Promise<string> {
        return this.http.put(`${environment.apiUrl}/v1/Notificacoes/ApagarNotificacao/${id}`, {}, {responseType: 'text'}).toPromise();
    }

    public deleteAllNotificationAtividade(vendedorId): Promise<string> {
        return this.http.delete(`${environment.baseUrl}/Notificacoes/apagar-todas?vendedorId=${vendedorId}`, {responseType: 'text'}).toPromise();
    }

    public deleteAllNotificationAniversario(): Promise<string> {
        return this.http.put<string>(`${environment.apiUrl}/v1/Notificacoes/ApagarTodasNotificacoes`, {responseType: 'text'}).toPromise();
    }

    public readAllNotificationAniversario(vendedorId): Promise<string> {
        return this.http.put<string>(`${environment.apiUrl}/v1/Notificacoes/LerTodasNotificacoes?vendedores=${vendedorId}`, {}).toPromise();
    }

}
